import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertDriverHomeLocationMutationVariables = Types.Exact<{
  location: Types.Locations_Insert_Input;
}>;


export type InsertDriverHomeLocationMutation = { __typename?: 'mutation_root', insert_locations_one?: { __typename?: 'locations', id: number, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, latitude?: number | null, longitude?: number | null, place_id?: string | null } | null };


export const InsertDriverHomeLocationDocument = gql`
    mutation InsertDriverHomeLocation($location: locations_insert_input!) {
  insert_locations_one(
    object: $location
    on_conflict: {constraint: idx_25692_primary, update_columns: [address_line_one, address_line_two, city, state, zip_code, latitude, longitude, place_id]}
  ) {
    id
    address_line_one
    address_line_two
    city
    state
    zip_code
    latitude
    longitude
    place_id
  }
}
    `;
export type InsertDriverHomeLocationMutationFn = Apollo.MutationFunction<InsertDriverHomeLocationMutation, InsertDriverHomeLocationMutationVariables>;

/**
 * __useInsertDriverHomeLocationMutation__
 *
 * To run a mutation, you first call `useInsertDriverHomeLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDriverHomeLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDriverHomeLocationMutation, { data, loading, error }] = useInsertDriverHomeLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useInsertDriverHomeLocationMutation(baseOptions?: Apollo.MutationHookOptions<InsertDriverHomeLocationMutation, InsertDriverHomeLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertDriverHomeLocationMutation, InsertDriverHomeLocationMutationVariables>(InsertDriverHomeLocationDocument, options);
      }
export type InsertDriverHomeLocationMutationHookResult = ReturnType<typeof useInsertDriverHomeLocationMutation>;
export type InsertDriverHomeLocationMutationResult = Apollo.MutationResult<InsertDriverHomeLocationMutation>;
export type InsertDriverHomeLocationMutationOptions = Apollo.BaseMutationOptions<InsertDriverHomeLocationMutation, InsertDriverHomeLocationMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/queries/insertDriverHomeLocation.mutation.gql}
 */
export async function insertDriverHomeLocation(
  variables: InsertDriverHomeLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertDriverHomeLocationMutation['insert_locations_one']>
export async function insertDriverHomeLocation(
  variables: InsertDriverHomeLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertDriverHomeLocationMutation>
export async function insertDriverHomeLocation(
  variables: InsertDriverHomeLocationMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertDriverHomeLocationMutation['insert_locations_one'] | InsertDriverHomeLocationMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertDriverHomeLocationMutation>(
    InsertDriverHomeLocationDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_locations_one
}